/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reset_Request_SubmitInputs */

const en_reset_request_submit = /** @type {(inputs: Reset_Request_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send reset link`)
};

/** @type {(inputs: Reset_Request_SubmitInputs) => LocalizedString} */
const ar_reset_request_submit = en_reset_request_submit;

/** @type {(inputs: Reset_Request_SubmitInputs) => LocalizedString} */
const he_reset_request_submit = en_reset_request_submit;

/** @type {(inputs: Reset_Request_SubmitInputs) => LocalizedString} */
const ur_reset_request_submit = en_reset_request_submit;

/** @type {(inputs: Reset_Request_SubmitInputs) => LocalizedString} */
const es_reset_request_submit = en_reset_request_submit;

/** @type {(inputs: Reset_Request_SubmitInputs) => LocalizedString} */
const fr_reset_request_submit = en_reset_request_submit;

/** @type {(inputs: Reset_Request_SubmitInputs) => LocalizedString} */
const de_reset_request_submit = en_reset_request_submit;

/** @type {(inputs: Reset_Request_SubmitInputs) => LocalizedString} */
const pt_reset_request_submit = en_reset_request_submit;

/** @type {(inputs: Reset_Request_SubmitInputs) => LocalizedString} */
const hi_reset_request_submit = en_reset_request_submit;

/** @type {(inputs: Reset_Request_SubmitInputs) => LocalizedString} */
const bn_reset_request_submit = en_reset_request_submit;

/**
* | output |
* | --- |
* | "Send reset link" |
*
* @param {Reset_Request_SubmitInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const reset_request_submit = /** @type {((inputs?: Reset_Request_SubmitInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reset_Request_SubmitInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_reset_request_submit(inputs)
	if (locale === "he") return he_reset_request_submit(inputs)
	if (locale === "ur") return ur_reset_request_submit(inputs)
	if (locale === "es") return es_reset_request_submit(inputs)
	if (locale === "fr") return fr_reset_request_submit(inputs)
	if (locale === "de") return de_reset_request_submit(inputs)
	if (locale === "pt") return pt_reset_request_submit(inputs)
	if (locale === "hi") return hi_reset_request_submit(inputs)
	if (locale === "bn") return bn_reset_request_submit(inputs)
	return /** @type {LocalizedString} */ ("Send reset link")
});